import React, { useEffect } from "react";
import DaumPostCode from "react-daum-postcode";

import "style/ModalStyles.css";

const Post = (props: any) => {
  useEffect(() => {
    document.body.style.cssText = `
          position: fixed; 
          top: -${window.scrollY}px;
          overflow-y: scroll;
          width: 100%;`;
    return () => {
      const scrollY = document.body.style.top;
      document.body.style.cssText = "";
      window.scrollTo(0, parseInt(scrollY || "0", 10) * -1);
    };
  }, []);

  const onCompletePost = (data: any) => {
    let fullAddr = data.address;
    let extraAddr = "";

    if (data.addressType === "R") {
      if (data.bname !== "") {
        extraAddr += data.bname;
      }
      if (data.buildingName !== "") {
        extraAddr +=
          extraAddr !== "" ? `, ${data.buildingName}` : data.buildingName;
      }
      fullAddr += extraAddr !== "" ? ` (${extraAddr})` : "";
    }

    props.setRegInputs({
      ...props.regInputs,
      ["addr"]: fullAddr,
    });
    props.setAddModalOpen(false);
  };

  return (
    <div className="modalBackground">
      <div className="modalContainer-msg" style={{ width: "25%" }}>
        <div className="mtitleCloseBtn">
          <button
            onClick={() => {
              props.setAddModalOpen(false);
            }}
          >
            ✕
          </button>
        </div>
        <div className="mbody">
          <DaumPostCode autoClose onComplete={onCompletePost} />
        </div>
      </div>
    </div>
  );
};

export default Post;
